
<app-language-bar  [languages]="languages"></app-language-bar>
<router-outlet></router-outlet>
<app-gs-icon-sprites></app-gs-icon-sprites>
<ngx-ui-loader></ngx-ui-loader>